import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'

const ThemeTypeInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setErrors,
  errors,
  ...props
}) => {
  const translate = useTranslate()
  const options = [
    {
      id: 'Question sur un appel de fonds ou relevé',
      name: 'Question sur un appel de fonds ou relevé',
    },
    {
      id: "Envoi d'un appel de fonds",
      name: "Envoi d'un appel de fonds",
    },
    { id: "Envoi d'un PV d'AG", name: "Envoi d'un PV d'AG" },
    { id: "Envoi d'un RCP", name: "Envoi d'un RCP" },
    {
      id: "Demande d'information sur une AG",
      name: "Demande d'information sur une AG",
    },
    {
      id: "Demande d'information sur une intervention",
      name: "Demande d'information sur une intervention",
    },
    { id: 'Autre', name: 'Autre' },
  ]
  useEffect(() => {
    setPayload(() => {
      return { ...payload, [source]: record[source] }
    })
  }, [])
  const handleChange = (event) => {
    if (required && !event) {
      setErrors(() => {
        return errors.map((err) => {
          return err.id == props.id
            ? {
                id: props.id,
                source: source,
                type: type,
                label: label,
              }
            : err
        })
      })
    } else {
      setErrors(() => {
        return errors.filter((item) => item.id !== props.id)
      })
    }
    setPayload(() => {
      return { ...payload, [source]: event.target.value }
    })
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="selectUrgent">
        {translate(label, { _: label })}
      </InputLabel>
      <Select
        required={required}
        error={required && errors.find((item) => item.id == props.id)}
        labelId="selectUrgent"
        id="selectUrgent-input"
        value={payload[source]}
        label="Age"
        onChange={handleChange}
      >
        {options.map((option) => {
          return <MenuItem value={option.id}>{option.name}</MenuItem>
        })}
      </Select>
    </FormControl>
  )
}
export default ThemeTypeInput
